import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'GiftCard',
        path: () => path.join(__dirname, './GiftCardBalance'),
        resolve: () => require.resolveWeak('./GiftCardBalance'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "GiftCard" */ './GiftCardBalance')]).then(
                (proms) => proms[0]
            ),
    })
);
